import { type Direction } from '@hello-pangea/dnd';

/**
 * Defines the general form of the underlying list component that is being used inside of the
 * {@link ListProvider}.
 *
 * 1. List: This form refers to the {@link List} component.
 * 2. Menu: This form refers to the {@link MenuList} component, where the list sits inside
 *    of a Menu.
 */
export enum ListStyle {
  List = 'List',
  Menu = 'Menu',
}

export const DirectionMap: Record<Direction, 'column' | 'row'> = {
  horizontal: 'row',
  vertical: 'column',
};

export enum ListValueMode {
  MultiValued = 'MultiValued',
  NonNullable = 'NonNullable',
  Nullable = 'Nullable',
}

export enum ListLoadingMode {
  Skeleton = 'Skeleton',
  Spinner = 'Spinner',
}
